import http from '../services/http';

async function fetchRemoteMenu() {
  const res = await http.get('/menu');
  const menu = res.data?.menu ?? res.data;

  if (!Array.isArray(menu)) {
    throw new Error('Invalid menu response');
  }

  return menu;
}

export async function getModules() {
  try {
    return await fetchRemoteMenu();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('No se pudo cargar el menú dinámico:', error);
    return [];
  }
}
